import React, { useState } from "react";
import { toAbsoluteUrl } from "../../../../../../../../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Button } from "react-bootstrap";
import {formatAmount, formatDate, transactionCat, transactionType, permissionAllow} from "../../../../../../../../../util/Helpers";
import {NavLink}  from "react-router-dom";
import { useSelector } from "react-redux";
import ViewTransactionModal from "../transactions/modal/ViewTransactionModal";
import { Permissions, PermissionType } from "../../../../../../../../../util/Permissions";

const RecentTransaction = props => {

    const adminUser = useSelector(state => state.auth.user);
    /* Transaction Modal State Management */
    const [transactionModal, setTransactionModal] = useState({showViewTransactionModal: false, details: null});

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setTransactionModal({...transactionModal, [modal]: !transactionModal[modal]})
    } 

    

    const Last4Transaction = _ => {

        const trnx = []

        if (props.transactions.length === 0){
            trnx.push(<tr key="trnx-0">
                <td colSpan="4" className="text-muted text-center">
                    No Transaction Record
                </td>
            </tr>)
        }
        else{

            for (let i = 0; i < 4; i++){
                if (props.transactions[i]){
                    trnx.push(<tr key={`trnx-${i}`}>
                                <td className="pl-3">
                                    <div className="d-flex align-items-center">
                                        <div>
                                            <span className="text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg">
                                                {transactionType(props.transactions[i])}
                                                <span className="text-muted pl-2">
                                                    - {transactionCat(props.transactions[i])}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    {props.transactions[i].comment}
                                </td>
                                <td>
                                    <span className="text-dark-75 d-block font-size-lg">
                                        {formatAmount(props.currency, props.transactions[i].tranAmount)}
                                    </span>
                                </td>
                                <td className="">
                                    {formatDate(props.transactions[i].created)}
                                </td>
                                <td>
                                    <span style={{whiteSpace: "nowrap"}}>
                                        <Button
                                            title="View Payment"
                                            className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                                            onClick={_ => setTransactionModal({...transactionModal, showViewTransactionModal: true, details: props.transactions[i]})}
                                        >
                                            <span className="svg-icon svg-icon-md svg-icon-primary">
                                                <SVG
                                                    title="View Transaction"
                                                    src={toAbsoluteUrl(
                                                        `/media/svg/icons/${(permissionAllow(adminUser, Permissions.TRANSACTIONS, PermissionType.UPDATE) && props.transactions[i].tranStatus === "pending") ? "Media/Play": "General/Eye-2" }.svg`
                                                    )}
                                                />
                                            </span>
                                        </Button>
                                    </span>
                                </td>
                            </tr>
                    )
                }
            }

        }

        return trnx;
    }

    return <div className="card card-custom card-stretch gutter-b">
        {/* <!--begin::Header--> */}
        <div className="card-header border-0 py-5">
            <h3 className="card-title align-items-start flex-column">
                <span className="card-label font-weight-bolder text-dark">Latest Transactions</span>
                <span className="text-muted mt-3 font-weight-bold font-size-sm">Last four transactions</span>
            </h3>
            <div className="card-toolbar">
                <NavLink 
                    to={`/users/view/${props.match.params.userId}/account-information/${props.match.params.accountId}/transactions`} 
                    className="btn btn-primary font-weight-bolder font-size-sm"
                >
                    <span className="svg-icon svg-icon-md svg-icon-white">
                        <SVG
                            title="Transactions"
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Calculator.svg")}
                        />
                    </span>
                    Transactions
                </NavLink>
            </div>
        </div>
        {/* <!--end::Header--> */}
        {/* <!--begin::Body--> */}
        <div className="card-body pt-0 pb-3">
            {/* <!--begin::Table--> */}
            <div className="table-responsive">
                <table className="table table-head-custom table-head-bg table-borderless table-vertical-center">
                    <thead>
                        <tr className="text-uppercase">
                            <th style={{minWidth: "100px"}} className="pl-7">
                                <span className="text-dark-75">Activities</span>
                            </th>
                            <th style={{minWidth: "100px"}}>DESCRIPTION</th>
                            <th style={{minWidth: "100px"}}>Amount</th>
                            <th style={{minWidth: "130px"}}>Date</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>

                        <Last4Transaction />
                        
                    </tbody>
                </table>
            </div>
            {/* <!--end::Table--> */}
        </div> 
        {/* <!--end::Body--> */}
        {transactionModal.showViewTransactionModal && <ViewTransactionModal {...transactionModal} onHide={toggleModal("showViewTransactionModal")}/> }
    </div>

    

}

export default RecentTransaction;